var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigerOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.1 224.809C223.1 224.809 209.724 267.333 219.601 292.806C219.601 292.806 225.98 296.915 227.215 300.613C228.45 304.105 221.659 314.376 221.659 314.376C221.659 314.376 208.078 315.814 203.757 314.376C199.229 312.938 179.886 271.442 180.298 246.174C180.298 220.906 223.1 224.809 223.1 224.809Z",
    fill: "#932F31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.927 254.39L195.938 284.588L180.093 258.499L224.541 219.878L216.927 254.39Z",
    fill: "#CE777C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.135 305.542C153.135 305.542 166.305 310.883 178.857 307.391L187.706 274.522L177.829 243.503L118.771 241.448L127.207 283.15L153.135 305.542Z",
    fill: "#932F31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.706 190.708L237.71 189.887C237.71 189.887 235.652 198.309 230.919 209.197C229.891 211.662 228.656 214.333 227.215 217.003C227.215 217.003 227.215 217.003 227.215 217.209C223.511 224.399 218.779 232.205 212.811 238.984C206.432 246.38 196.555 251.926 186.472 256.035C172.479 261.787 158.897 264.457 153.136 265.279C153.959 265.074 151.901 259.527 151.901 265.485C150.461 265.69 149.432 265.895 149.432 265.895C149.432 265.895 157.251 251.926 152.313 227.48C152.313 227.48 167.952 216.182 177.006 200.363C181.121 193.173 184.002 185.367 183.385 177.15L227.01 161.948L225.158 171.603C225.158 171.603 232.771 184.34 244.706 190.708Z",
    fill: "url(#paint0_radial_83_4032)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.385 177.355C183.385 177.355 213.84 187.421 225.158 171.603L227.01 161.948L183.385 177.355Z",
    fill: "url(#paint1_radial_83_4032)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.313 317.252C209.313 317.252 196.966 319.101 192.027 317.252C187.089 315.404 156.634 289.314 154.164 282.124C151.695 274.934 151.901 263.43 151.901 263.43C150.872 272.058 147.374 278.837 144.493 282.946C142.435 285.822 140.789 287.465 140.789 287.465C140.789 287.465 147.374 292.806 151.078 297.326C152.107 298.558 152.724 299.585 153.135 300.613C153.341 301.229 153.547 302.051 153.547 302.667C153.341 307.803 147.785 314.787 147.785 314.787C147.785 314.787 130.088 316.842 127.002 313.966C123.915 311.09 113.009 288.287 112.597 284.178C112.186 280.07 114.244 276.372 114.244 276.372C100.045 247.612 102.72 210.018 110.128 203.239C117.536 196.46 125.355 197.282 142.229 191.941C158.897 186.599 164.865 180.847 164.865 180.847C170.832 176.739 183.179 177.355 183.179 177.355C184.825 181.258 184.208 212.689 184.619 240.833C185.031 268.977 200.876 293.833 200.876 293.833C200.876 293.833 211.37 296.915 212.605 302.051C214.045 307.186 209.313 317.252 209.313 317.252Z",
    fill: "url(#paint2_radial_83_4032)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.483 205.703L104.779 219.673C104.779 219.673 69.7967 222.549 46.7496 191.734C34.8146 175.916 33.1683 160.304 33.9915 147.772V147.567C34.8146 135.857 37.9012 127.024 37.0781 123.326C36.6666 121.683 35.8434 120.039 34.6088 118.396C30.4932 113.055 22.2622 107.919 16.5004 101.14C9.09241 92.1011 20.8217 71.969 35.8434 72.1744C45.1034 72.3798 56.2154 85.5273 63.2118 99.0856C67.3274 107.303 70.0025 115.725 69.5909 121.272C68.562 136.063 59.7136 158.249 74.118 180.846C88.3166 203.649 108.483 205.703 108.483 205.703Z",
    fill: "url(#paint3_radial_83_4032)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7995 99.2917C37.0773 98.0591 34.4022 117.78 34.4022 118.602C30.2867 113.261 22.0556 108.125 16.2938 101.346C8.88587 92.3071 20.6152 72.175 35.6369 72.3805C44.8969 72.5859 56.0088 85.7334 62.7995 99.2917Z",
    fill: "url(#paint4_linear_83_4032)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.707 190.708L237.711 189.886C237.711 189.886 235.653 198.309 230.92 209.197C213.429 220.29 184.62 214.127 184.62 214.127C182.563 209.607 179.888 204.883 177.007 200.774C170.216 190.708 162.396 182.902 162.396 182.902L165.277 171.398L226.805 162.153L223.718 172.836C223.718 172.63 232.772 184.34 244.707 190.708Z",
    fill: "#CE777C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.948 23.283C231.948 23.283 234.417 6.23237 239.356 2.74007C244.294 -0.546797 260.551 -0.546798 266.518 14.8604C272.486 30.2676 270.634 40.3336 268.165 44.4422C266.724 46.9074 256.229 49.3725 256.229 49.3725L231.948 23.283Z",
    fill: "url(#paint5_linear_83_4032)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305 109.152L298.827 108.33C298.415 109.152 293.271 120.862 285.451 131.544C281.747 136.474 277.632 141.405 273.105 144.691C271.253 146.129 269.195 147.362 267.137 148.184C267.137 148.184 264.462 157.633 252.938 165.029C252.321 164.824 239.769 160.92 226.805 161.947C226.805 161.947 193.88 176.738 166.512 180.642C139.144 184.339 108.277 156.606 108.277 156.606L95.7246 161.537C96.3419 161.331 103.133 154.141 108.689 140.377C110.129 136.474 111.569 132.16 112.804 127.435C117.949 104.633 122.887 59.0275 144.082 40.7443C144.082 40.7443 165.072 14.4493 204.375 5.82129C203.346 6.02672 199.025 7.67015 195.115 11.7787C195.115 11.7787 216.722 16.5036 231.743 23.2828C234.83 24.7208 237.711 26.1588 239.974 27.5968C253.762 36.6357 264.05 61.0818 270.224 74.8455C274.133 83.4735 286.686 94.5667 295.534 101.757C301.09 106.276 305 109.152 305 109.152Z",
    fill: "url(#paint6_radial_83_4032)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.689 140.377C108.689 140.377 118.361 159.482 134.617 163.591C155.607 168.932 163.838 165.44 163.838 165.44C163.838 165.44 112.599 156.195 113.834 123.121L108.689 140.377Z",
    fill: "#9D3D3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.772 97.4434C118.772 97.4434 119.595 116.548 121.653 126.409C123.711 136.269 162.191 160.921 197.173 154.142C197.173 154.142 176.184 163.181 158.075 160.099C139.761 157.223 125.151 134.626 120.83 128.052C116.508 121.479 114.039 120.862 114.039 120.862L118.772 97.4434Z",
    fill: "#9D3D3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.581 36.6351C147.581 36.6351 161.368 25.9528 177.007 28.6234C192.646 31.294 207.051 45.8794 210.343 55.1238C210.343 55.1238 205.61 40.1274 196.144 26.98C186.679 13.8325 175.773 16.0922 175.773 16.0922C175.773 16.0922 159.31 23.4877 147.581 36.6351Z",
    fill: "#9D3D3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.115 11.7793C195.115 11.7793 217.545 31.7059 231.949 86.3501C231.949 86.3501 237.094 47.7294 218.574 18.353C218.574 18.353 203.758 12.3956 195.115 11.7793Z",
    fill: "#9D3D3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.48 22.4609C229.48 22.4609 235.653 38.0736 235.859 56.7676C235.859 56.7676 244.09 41.3604 243.473 30.2672C243.473 30.2672 238.328 25.3369 229.48 22.4609Z",
    fill: "#9D3D3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.826 200.158C184.826 200.158 170.01 189.27 155.605 205.91C155.605 205.91 175.772 199.13 184.62 205.91L184.826 200.158Z",
    fill: "#9D3D3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.62 221.933C184.62 221.933 166.718 217.414 152.931 236.724C152.931 236.724 151.079 242.271 150.667 249.666C150.667 249.666 164.866 236.313 184.62 233.232V221.933Z",
    fill: "#9D3D3A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.826 240.832C184.826 240.832 169.598 238.162 159.927 254.802C159.927 254.802 168.158 248.844 185.443 249.666L184.826 240.832Z",
    fill: "#9D3D3A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.913 263.019C187.913 263.019 173.097 257.883 161.162 275.139C161.162 275.139 177.83 267.744 190.382 271.03L187.913 263.019Z",
    fill: "#9D3D3A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.115 282.534C195.115 282.534 178.447 281.507 168.981 298.763L174.126 303.488C174.126 303.488 183.18 289.724 196.967 286.643L195.115 282.534Z",
    fill: "#9D3D3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.974 196.666C125.974 196.666 122.682 198.31 117.743 206.732C112.805 215.155 115.685 232 115.685 232C115.685 232 121.036 227.481 121.653 215.771C122.27 204.267 129.472 195.434 129.472 195.434L125.974 196.666Z",
    fill: "#9D3D3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.353 194.611C132.353 194.611 122.888 204.266 125.974 217.003C125.974 217.003 136.263 195.227 147.992 189.681C147.992 189.886 138.938 193.789 132.353 194.611Z",
    fill: "#9D3D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.45 276.371C114.45 276.371 126.18 283.972 140.172 282.329C140.172 282.329 130.707 281.302 110.129 265.895L114.45 276.371Z",
    fill: "#9D3D3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.837 254.802C106.837 254.802 114.862 265.279 130.913 269.798C147.169 274.112 151.079 269.798 151.079 269.798C151.079 269.798 151.696 266.717 151.902 263.43C151.902 263.43 142.23 269.387 130.295 266.1C118.36 262.814 104.573 241.654 104.573 241.654C104.573 241.654 105.808 250.693 106.837 254.802Z",
    fill: "#9D3D3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6089 141.611C34.6089 141.611 42.0169 109.154 67.739 111.208C67.739 111.208 70.0026 117.371 69.1795 123.123C69.1795 122.917 47.5728 121.274 34.6089 141.611Z",
    fill: "#9D3D3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5332 133.803C67.5332 133.803 45.9266 130.106 35.6377 149.005C35.6377 149.005 47.7785 134.625 65.8869 144.691L67.5332 133.803Z",
    fill: "#9D3D3A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3266 166.468C67.3266 166.468 54.98 162.565 48.8066 180.437C48.8066 180.437 56.6262 169.344 69.5901 173.247L67.3266 166.468Z",
    fill: "#9D3D3A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4112 186.189C77.4112 186.189 67.1224 185.162 65.8877 201.185C65.8877 201.185 72.6783 194.406 81.5268 191.119L77.4112 186.189Z",
    fill: "#9D3D3A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4077 193.789C84.4077 193.789 77.6171 195.432 75.3535 205.909C75.3535 205.909 84.8193 200.157 92.6388 199.952L84.4077 193.789Z",
    fill: "#9D3D3A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.825 108.331C298.208 109.769 284.215 140.994 267.342 148.184C267.342 148.184 264.666 157.634 253.143 165.03C253.143 165.03 240.385 160.716 227.009 161.948C227.009 161.948 194.085 176.739 166.717 180.642C139.348 184.34 108.482 156.607 108.482 156.607L95.9292 161.537C95.9292 161.537 103.131 154.347 108.687 140.173C108.687 140.173 117.947 163.797 147.374 165.851C177.005 167.7 202.522 155.58 212.605 144.487C222.894 133.393 234.829 130.312 234.829 130.312C234.829 130.312 245.323 131.134 256.847 129.696C266.724 128.463 274.544 126.203 274.544 126.203C290.183 121.889 298.208 109.153 298.825 108.331Z",
    fill: "url(#paint7_radial_83_4032)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.082 40.539C144.082 40.539 140.789 18.9689 116.713 14.8604C116.713 14.8604 97.5761 18.5581 93.6664 36.4304C89.9624 54.3028 100.251 70.5317 105.601 75.462C110.746 80.3923 124.327 75.462 124.327 75.462C124.327 75.462 132.147 52.043 144.082 40.539Z",
    fill: "url(#paint8_linear_83_4032)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.432 137.502C149.432 137.502 161.984 152.704 185.443 150.444C208.901 148.184 222.688 132.982 224.54 128.668C226.392 124.354 208.696 74.4351 190.176 68.0668C171.656 61.6985 149.638 91.2803 146.757 104.839C143.876 118.397 146.962 135.037 149.432 137.502Z",
    fill: "url(#paint9_radial_83_4032)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.26 114.288C252.527 108.331 249.852 64.1635 253.144 59.4386C256.437 54.7137 267.137 67.4503 271.664 76.9001C276.191 86.3498 281.13 100.114 280.307 104.838C278.866 113.466 272.281 117.986 267.137 118.808C263.639 119.218 259.729 117.575 257.26 114.288Z",
    fill: "url(#paint10_radial_83_4032)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.992 134.626C147.992 134.626 143.67 119.63 148.403 104.017C154.577 83.6796 169.598 71.5593 185.032 69.7104C196.555 68.2724 211.165 91.4859 211.165 91.4859C211.165 91.4859 200.671 67.4507 185.237 64.7801C169.804 62.1095 150.873 84.5013 146.757 99.7031C141.613 118.192 147.992 134.626 147.992 134.626Z",
    fill: "#9D3D3A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.144 97.8536C253.144 97.8536 246.97 59.8492 251.497 54.508C256.024 49.1669 270.223 71.9695 274.339 83.2681C274.339 83.2681 260.552 56.7677 254.378 58.6166C249.234 60.4655 253.144 97.8536 253.144 97.8536Z",
    fill: "#9D3D3A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.981 132.366C167.335 121.684 171.862 107.509 182.768 100.936C193.674 94.3619 204.169 98.2651 208.696 103.812C213.223 109.564 218.573 128.874 208.696 140.378C200.053 150.65 172.274 152.088 168.981 132.366Z",
    fill: "url(#paint11_linear_83_4032)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.078 118.808C264.872 118.808 264.872 118.808 264.667 118.808C261.786 118.192 259.522 116.754 257.876 114.699C254.584 110.796 253.143 104.839 253.143 98.6759C253.143 97.2379 253.349 95.7999 253.349 94.5673C253.966 90.6642 254.995 87.7882 256.641 85.9393C258.493 83.4741 260.757 82.2416 262.815 81.8307C266.93 80.8036 272.898 87.1719 275.573 97.8542C278.454 108.742 273.721 120.451 265.078 118.808Z",
    fill: "url(#paint12_linear_83_4032)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.981 132.367C168.981 132.367 164.66 117.165 175.772 102.785C187.089 88.4047 206.227 93.5404 211.371 108.948C211.371 108.948 207.255 97.4436 192.028 97.8545C178.035 98.4707 167.952 115.111 168.981 132.367Z",
    fill: "#75272C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.295 143.665C196.841 143.665 204.58 135.755 204.58 125.998C204.58 116.241 196.841 108.331 187.295 108.331C177.749 108.331 170.01 116.241 170.01 125.998C170.01 135.755 177.749 143.665 187.295 143.665Z",
    fill: "url(#paint13_radial_83_4032)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.025 125.998C199.025 132.572 193.88 137.913 187.295 137.913C180.916 137.913 175.566 132.572 175.566 125.998C175.566 119.424 180.71 114.083 187.295 114.083C193.88 114.083 199.025 119.424 199.025 125.998Z",
    fill: "#75272C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.458 102.578C271.458 109.974 268.783 116.137 264.873 118.807C261.992 118.191 259.729 116.753 258.082 114.699C254.79 110.796 253.35 104.838 253.35 98.6752C253.35 97.2372 253.555 95.7992 253.555 94.5667C254.173 90.6635 255.202 87.7875 256.848 85.9386C258.082 85.1169 259.317 84.7061 260.758 84.7061C266.519 84.9115 271.458 92.7178 271.458 102.578Z",
    fill: "url(#paint14_radial_83_4032)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.108 102.99C266.108 109.564 262.815 114.905 258.906 114.905C258.7 114.905 258.288 114.905 258.082 114.905C254.79 111.002 253.35 105.045 253.35 98.8819C253.35 97.4438 253.555 96.0058 253.555 94.7733C254.79 92.5135 256.848 90.8701 258.906 90.8701C263.021 90.8701 266.108 96.2113 266.108 102.99Z",
    fill: "#75272C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.046 119.014C214.046 119.014 217.75 126.615 216.721 131.134C215.693 135.653 207.873 141.405 207.873 141.405C207.873 141.405 215.075 134.215 214.046 119.014Z",
    fill: "#BD4C3A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.067 139.761C172.067 139.761 176.8 148.594 191.204 149.005C205.609 149.416 211.576 136.269 211.576 136.269C211.576 136.269 205.609 146.745 192.027 147.773C178.652 148.8 172.067 139.761 172.067 139.761Z",
    fill: "#BD4C3A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.125 140.378C174.125 140.378 175.359 135.448 180.915 132.366C180.915 132.366 185.442 133.804 191.616 133.804L191.41 146.952C191.41 146.952 182.767 147.568 174.125 140.378Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.789 108.947C254.789 108.947 251.291 93.5399 257.67 85.7335C264.049 77.9272 273.103 87.7878 274.75 94.3616C274.75 94.3616 270.634 81.625 264.049 79.3652C263.843 79.3652 247.999 81.4195 254.789 108.947Z",
    fill: "#75272C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.082 114.699C258.082 114.699 265.49 120.656 272.692 116.137C279.688 111.617 280.511 104.222 280.511 104.222C280.511 104.222 280.305 115.109 272.28 119.013C263.843 122.916 258.082 114.699 258.082 114.699Z",
    fill: "#BD4C3A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.818 90.4588L259.728 99.9085C259.728 99.9085 267.136 93.5402 273.72 93.3348C273.72 93.3348 270.84 86.5556 265.284 84.9122C259.933 83.2687 255.818 90.4588 255.818 90.4588Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.429 116.137L262.198 110.385L263.844 105.249L274.544 104.222C274.544 104.222 276.808 109.357 270.429 116.137Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.504 134.626C237.504 134.626 235.446 132.777 236.064 130.518C236.064 130.518 259.728 130.723 274.544 126.409C274.544 126.409 272.486 133.394 267.136 138.119L262.403 138.735C262.403 138.735 254.378 132.983 241.414 135.859L237.504 134.626Z",
    fill: "url(#paint15_radial_83_4032)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.859 130.723L231.743 128.053C231.743 128.053 238.122 113.467 257.671 115.111C257.671 115.111 270.635 122.506 274.339 126.615C274.339 126.615 256.848 132.367 235.859 130.723Z",
    fill: "#FF9F30"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.428 146.54C270.428 146.54 268.576 145.102 261.374 146.54C254.378 147.978 249.851 150.854 241.825 151.06C233.8 151.06 227.627 143.664 227.627 143.664L226.392 144.28C226.392 144.28 232.977 151.06 242.031 151.881C251.085 152.703 262.197 147.567 267.342 148.389L270.428 146.54Z",
    fill: "url(#paint16_radial_83_4032)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.154 139.556C232.154 139.556 224.335 140.377 223.923 147.773C223.923 147.773 229.891 140.788 232.154 139.556Z",
    fill: "#BD4C3A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.175 55.7416C133.175 55.7416 123.092 32.1172 108.482 34.1715C96.9582 35.815 94.2831 43.2104 95.9293 52.2493C97.164 59.6448 101.691 72.3814 110.128 74.8465C118.359 77.3117 125.767 72.3814 125.767 72.3814C125.767 72.3814 130.706 59.6448 133.175 55.7416Z",
    fill: "url(#paint17_radial_83_4032)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.205 34.9918C248.205 34.9918 252.937 8.90227 259.728 9.51856C266.519 10.1348 270.017 28.0072 268.988 37.2515C267.959 46.4958 261.786 48.3447 257.465 48.3447C257.259 48.1393 251.291 38.2787 248.205 34.9918Z",
    fill: "url(#paint18_radial_83_4032)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.938 165.03C252.321 164.824 239.769 160.921 226.805 161.948C226.805 161.948 193.88 176.739 166.512 180.642C139.144 184.34 108.277 156.607 108.277 156.607L95.7246 161.537C96.3419 161.332 103.133 154.142 108.689 140.378C110.129 136.475 111.569 132.161 112.804 127.436C117.949 104.634 122.887 59.0283 144.082 40.7451C143.671 41.7723 124.122 80.8038 133.176 126.204C142.436 172.22 184.003 168.111 202.317 163.797C220.631 159.483 223.924 155.785 223.924 155.785C223.924 155.785 247.588 160.305 252.938 165.03Z",
    fill: "url(#paint19_linear_83_4032)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.657 131.545C281.953 136.475 277.837 141.406 273.31 144.692C278.866 136.064 274.75 126.409 274.75 126.409C280.306 127.025 284.01 129.901 285.657 131.545Z",
    fill: "url(#paint20_linear_83_4032)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.175 55.74C133.175 55.74 106.63 49.988 99.4277 79.5698C99.4277 79.5698 106.013 70.1201 118.565 64.7789C118.565 64.7789 108.276 81.0078 114.449 100.113C114.449 100.113 118.153 82.4458 130.912 73.2015C130.706 72.9961 138.525 64.9843 133.175 55.74Z",
    fill: "url(#paint21_radial_83_4032)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.941 32.5273C245.941 32.5273 265.284 35.8142 271.457 52.454C271.457 52.454 261.374 42.5934 253.76 42.3879L245.941 32.5273Z",
    fill: "url(#paint22_radial_83_4032)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.215 217.208C223.511 224.398 218.778 232.204 212.811 238.984C206.432 246.379 196.555 251.926 186.471 256.034C184.825 248.844 184.825 234.053 184.825 234.053C184.825 234.053 195.32 243.914 207.872 236.313C219.602 229.123 226.392 218.441 227.215 217.208Z",
    fill: "url(#paint23_linear_83_4032)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.547 302.667C153.341 307.803 147.785 314.788 147.785 314.788C147.785 314.788 130.088 316.842 127.002 313.966C123.915 311.09 113.009 288.287 112.597 284.179C112.597 284.179 118.976 297.121 128.648 302.462C138.525 307.598 153.135 302.873 153.547 302.667Z",
    fill: "url(#paint24_linear_83_4032)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.342 300.612C153.548 301.228 153.754 302.05 153.754 302.666L151.284 297.325C152.107 298.352 152.93 299.585 153.342 300.612Z",
    fill: "url(#paint25_linear_83_4032)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.313 317.252C209.313 317.252 196.966 319.101 192.027 317.252C187.089 315.403 156.634 289.314 154.164 282.124C151.695 274.933 151.901 263.429 151.901 263.429C150.872 272.057 147.374 278.837 144.493 282.945C144.493 282.945 151.901 263.429 146.139 252.336C140.377 241.243 130.912 236.724 130.912 236.724H152.93C152.93 236.724 150.872 247.406 152.93 260.143C154.988 272.879 171.861 297.531 184.619 302.05C197.378 306.57 212.605 302.05 212.605 302.05C214.046 307.186 209.313 317.252 209.313 317.252Z",
    fill: "url(#paint26_linear_83_4032)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.291 317.869C194.291 317.869 195.731 312.527 195.525 309.446C195.32 306.365 193.056 303.899 193.056 303.899C193.056 303.899 196.554 306.365 197.172 309.857C197.789 313.349 195.525 317.869 195.525 317.869H194.291Z",
    fill: "#BD4C3A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.049 317.458C207.049 317.458 209.519 307.392 208.696 305.338C207.872 303.283 207.049 302.667 207.049 302.667C207.049 302.667 209.107 302.667 209.93 305.748C210.753 308.83 207.461 317.458 207.461 317.458H207.049Z",
    fill: "#BD4C3A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.564 288.903C118.564 288.903 121.24 297.942 133.175 302.667C145.11 307.391 153.752 302.667 153.752 302.667C153.752 302.667 155.399 300.201 140.994 287.465C140.994 287.465 130.294 293.422 118.564 288.903Z",
    fill: "#FF9F30"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.94 315.403C131.94 315.403 136.055 309.24 136.055 305.337C136.055 301.434 133.998 297.941 133.998 297.941C133.998 297.941 137.702 302.461 137.496 306.775C137.29 310.883 133.175 315.608 133.175 315.608H131.94V315.403Z",
    fill: "#BD4C3A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.905 315.198C144.905 315.198 147.786 311.09 149.02 306.776C150.049 302.462 148.403 299.175 148.403 299.175C148.403 299.175 150.667 302.873 149.843 306.981C149.226 311.09 145.522 315.198 145.522 315.198H144.905Z",
    fill: "#BD4C3A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.605 301.229C212.605 301.229 206.432 303.078 198.818 303.283C191.204 303.489 183.59 300.202 183.59 300.202C183.59 300.202 191.821 293.423 201.081 293.833C201.081 293.833 212.193 296.504 212.605 301.229Z",
    fill: "#FF9F30"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.16 224.604C104.16 224.604 105.806 257.062 118.153 278.632C118.153 278.632 113.214 278.838 112.803 284.384C112.803 284.384 111.774 280.276 114.449 276.578C114.449 276.373 102.514 255.213 104.16 224.604Z",
    fill: "#CE777C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.482 205.704L104.778 219.673C104.778 219.673 69.7959 222.549 46.7489 191.734C34.8138 175.916 33.1676 160.304 33.9907 147.772C33.3733 167.288 42.2218 194.816 67.5324 205.909C92.8429 216.797 108.482 205.704 108.482 205.704Z",
    fill: "#CE777C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.025 172.631C199.025 172.631 217.751 165.441 224.541 161.538C231.332 157.84 252.939 164.825 252.939 164.825C252.939 164.825 235.859 160.922 226.805 163.387C217.751 166.057 199.025 172.631 199.025 172.631Z",
    fill: "#9D3D3A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M202.522 121.478C204.681 121.478 206.431 119.731 206.431 117.575C206.431 115.419 204.681 113.672 202.522 113.672C200.362 113.672 198.612 115.419 198.612 117.575C198.612 119.731 200.362 121.478 202.522 121.478Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.429 93.3342C270.429 94.3614 269.606 95.1831 268.577 95.1831C267.548 95.1831 266.725 94.3614 266.725 93.3342C266.725 92.3071 267.548 91.4854 268.577 91.4854C269.606 91.6908 270.429 92.5125 270.429 93.3342Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.739 101.962C295.739 101.962 289.36 123.943 277.631 122.711C265.902 121.478 257.259 114.493 257.259 114.493C246.353 85.1171 250.057 46.4964 250.057 46.4964C246.147 32.1163 232.977 23.8991 232.154 23.4883C235.241 24.9263 238.122 26.3643 240.385 27.8023C254.172 36.8412 264.461 61.2873 270.635 75.051C274.339 83.4736 286.891 94.7722 295.739 101.962Z",
    fill: "url(#paint27_linear_83_4032)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.858 130.723C235.858 130.723 247.381 132.571 260.551 130.928C273.515 129.49 274.956 126.203 274.956 126.203C274.956 126.203 260.14 130.723 235.858 130.723Z",
    fill: "#75272C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.705 72.9971C130.705 72.9971 121.034 111.001 113.626 122.916C113.626 122.916 116.713 105.455 119.388 94.5671C122.063 83.6794 122.68 81.2142 122.68 81.2142C122.68 81.2142 126.384 74.8459 130.705 72.9971Z",
    fill: "#9D3D3A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.601 69.7109C162.601 69.7109 171.038 59.0286 182.973 61.0829C194.908 63.1372 206.432 75.6684 206.432 75.6684C206.432 75.6684 198.201 57.3852 185.031 54.0983C171.861 50.606 162.601 69.7109 162.601 69.7109Z",
    fill: "#FF9F30"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.471 256.034C186.471 256.034 206.226 249.255 219.601 229.944C219.601 229.944 213.016 248.844 187.089 259.321L186.471 256.034Z",
    fill: "#75272C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.201 244.735C141.201 244.735 151.902 253.363 151.49 267.127L152.107 263.224C152.107 263.224 150.05 252.336 151.078 245.352C151.078 245.557 145.111 245.762 141.201 244.735Z",
    fill: "#75272C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.097 240.627C116.097 240.627 112.187 258.499 118.154 269.592C124.122 280.686 146.346 277.193 146.346 277.193C146.346 277.193 150.461 265.689 147.375 254.596C144.288 243.708 130.913 236.518 130.913 236.518C130.913 236.518 120.624 235.08 116.097 240.627Z",
    fill: "#FFC763"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.28 35.6099C158.28 35.6099 182.562 51.428 209.107 52.4551C235.858 53.4823 242.032 32.5285 242.032 32.5285C242.032 32.5285 223.923 16.2996 201.082 15.067C178.241 13.8344 158.28 35.6099 158.28 35.6099Z",
    fill: "#FFC763"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7021 92.3072C23.7021 92.3072 35.843 122.505 50.4532 126.203C65.2691 129.901 67.5327 119.424 67.5327 119.424C67.5327 119.424 64.2402 98.2646 55.8034 89.4312C47.3665 80.5977 40.7816 75.6674 40.7816 75.6674C40.7816 75.6674 22.0559 74.6403 23.7021 92.3072Z",
    fill: "#FFC763"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.825 135.858C241.825 135.858 253.142 130.928 262.814 138.734C262.814 138.734 253.348 132.982 241.825 135.858Z",
    fill: "#75272C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.05 214.026) scale(49.9222 49.8377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.133 171.258) scale(16.7225 16.6942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.982 211.144) scale(62.9695 62.863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.224 146.098) scale(61.9918 61.887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_4032",
    x1: 14.0303,
    y1: 95.473,
    x2: 62.8252,
    y2: 95.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FFC772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_83_4032",
    x1: 251.12,
    y1: 49.4652,
    x2: 251.12,
    y2: 1.09664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.323 50.2704) scale(96.5539 96.3907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.37 144.685) scale(76.2614 76.1325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_83_4032",
    x1: 118.485,
    y1: 77.8747,
    x2: 118.485,
    y2: 14.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.064 108.994) scale(40.7229 40.654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265.939 88.7881) scale(23.664 23.624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_83_4032",
    x1: 191.495,
    y1: 147.77,
    x2: 191.495,
    y2: 97.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_83_4032",
    x1: 264.858,
    y1: 119.038,
    x2: 264.858,
    y2: 81.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.663 135.68) scale(17.2467 17.6701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.017 111.167) scale(11.0358 11.0172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.327 132.561) scale(14.3684 14.3441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.396 147.751) scale(15.8234 15.7967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.29 54.7913) scale(19.8437 19.8102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.644 28.7866) scale(15.5685 15.5422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_83_4032",
    x1: 174.453,
    y1: 181.049,
    x2: 174.453,
    y2: 40.5863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_83_4032",
    x1: 279.406,
    y1: 144.677,
    x2: 279.406,
    y2: 126.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.209 77.5889) scale(20.232 20.1978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_83_4032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.639 42.4734) scale(11.4752 11.4558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_83_4032",
    x1: 184.726,
    y1: 236.632,
    x2: 227.234,
    y2: 236.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_83_4032",
    x1: 112.721,
    y1: 299.932,
    x2: 153.649,
    y2: 299.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#AC6393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_83_4032",
    x1: 151.187,
    y1: 299.929,
    x2: 153.671,
    y2: 299.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_83_4032",
    x1: 131.014,
    y1: 277.334,
    x2: 213.044,
    y2: 277.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#AC6393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_83_4032",
    x1: 263.792,
    y1: 122.65,
    x2: 263.792,
    y2: 23.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigerOk);
export default __webpack_public_path__ + "static/media/tiger_ok.a28ecc26767f3fdc9052e9d6fa697a2c.svg";
export { ForwardRef as ReactComponent };